import BackButton from './BackButton';
import QuoteStatus from './QuoteStatus';
import QuoteActionButtons from './QuoteActionButtons';
import { Card } from '@getdokan/dokan-ui';
import { __, sprintf } from '@wordpress/i18n';
import { Quote } from '../../types/quote';
import { Slot } from '@wordpress/components';
import { DateTimeHtml } from '@dokan/components';
import { QUOTE_DETAILS_SLOTS } from '../Common/QuoteDetailsSlot';

interface QuoteHeaderProps {
    quote: Quote;
    quoteUpdated: boolean;
}

const QuoteHeader: React.FC< QuoteHeaderProps > = ( {
    quote,
    quoteUpdated,
} ) => {
    return (
        <Card className="rounded-lg">
            <Card.Body className="p-4 shadow rounded-lg">
                <div className="flex items-center justify-between bg-white">
                    <div className="flex items-center gap-4">
                        { /*<BackButton link={Link} />*/ }
                        <div className="quote-context space-y-2 flex flex-col">
                            <div className="flex items-center gap-2.5">
                                <h2 className="text-lg font-semibold m-0">
                                    { sprintf(
                                        /* translators: %1$s: Quote ID */
                                        __( 'Quote #%1$s', 'dokan' ),
                                        quote?.quote_id
                                    ) }
                                </h2>

                                { /* Before quote details badge slot */ }
                                <Slot
                                    name={
                                        QUOTE_DETAILS_SLOTS.BEFORE_QUOTE_BADGE
                                    }
                                    fillProps={ { quote } }
                                />

                                <QuoteStatus status={ quote?.status } />

                                { /* After quote details badge slot */ }
                                <Slot
                                    name={
                                        QUOTE_DETAILS_SLOTS.AFTER_QUOTE_BADGE
                                    }
                                    fillProps={ { quote } }
                                />
                            </div>
                            <span className="text-sm text-gray-500">
                                <DateTimeHtml date={ quote?.created_at } />
                            </span>
                        </div>
                    </div>

                    { /* Before quote details badge slot */ }
                    <Slot
                        name={ QUOTE_DETAILS_SLOTS.BEFORE_ACTION_BUTTON }
                        fillProps={ { quote } }
                    />

                    <div className="flex items-center gap-3">
                        <QuoteActionButtons
                            quote={ quote }
                            quoteUpdated={ quoteUpdated }
                        />
                    </div>

                    { /* After quote details badge slot */ }
                    <Slot
                        name={ QUOTE_DETAILS_SLOTS.AFTER_ACTION_BUTTON }
                        fillProps={ { quote } }
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default QuoteHeader;
